import { RootState } from "redux/rootReducer";

export const selectIsLoadingConsultationSettings = (state: RootState) =>
  state.consultationSettings.loading;
export const selectConsultationSettingsErrorMessage = (state: RootState) =>
  state.consultationSettings.error;
export const consultationSettingsDataResponse = (state: RootState) =>
  state.consultationSettings.consultationSettingsResponse;
